import _toConsumableArray from "E:/Jweb/\u7ED3\u8BFE\u4F5C\u4E1A/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getArticleDetails, getPreviousNextArticle, updateViewCount } from "../../api/article";
import { reactive, nextTick, ref } from "vue";
import { ElMessage } from "element-plus";
import markdownIt from "../../utils/markdown-it";
import { mapState } from "../../store/map";
import { useDefaultThumbnail, defaultThumbnail } from "../../utils/thumbnail";
import buildCodeBlock from "../../utils/code-block";
import { renderByMathjax, initMathJax } from "../../utils/mathjax";
import router from "../../router";
import { getCommentList, addComment, deleteComment, updateComment } from "../../api/comment";
import { getUserInfo } from "../../utils/storage";
export default {
  name: "ArticleDetails",
  setup: function setup(props) {
    window.scrollTo({
      top: 0
    });

    var _mapState = mapState("adminAbout"),
        adminInfo = _mapState.adminInfo,
        isAdmin = _mapState.isAdmin;

    var articleLoaded = ref(false);
    var articleUrl = ref(window.location.href);
    var previousArticle = reactive({});
    var nextArticle = reactive({});
    var lightBoxRef = ref(); // 获取文章内容

    var articleDetails = reactive({
      createTime: ""
    });
    getArticleDetails(props.id).then(function (data) {
      Object.assign(articleDetails, data);
      articleDetails.content = markdownIt.render(data.content);
      nextTick(function () {
        initMathJax({}, function () {
          renderByMathjax(".article-content");
          renderByMathjax(".comment-item-content");
        });
        buildCodeBlock(".article-content");
        articleLoaded.value = true;
      }).then(function () {
        lightBoxRef.value.addImageClickedListener();
      });
    });
    updateViewCount(props.id); // 获取上一篇和下一篇文章

    getPreviousNextArticle(props.id).then(function (data) {
      if (data.previous) {
        Object.assign(previousArticle, data.previous);

        if (!previousArticle.thumbnail) {
          previousArticle.thumbnail = defaultThumbnail;
        }
      }

      if (data.next) {
        Object.assign(nextArticle, data.next);

        if (!nextArticle.thumbnail) {
          nextArticle.thumbnail = defaultThumbnail;
        }
      }
    }); // 获取评论列表

    var comments = reactive([]);
    var commentCount = ref(0);
    var commentPageSize = 5;
    var currentCommentPageNum = ref(1);
    onCurrentCommentPageChanged(1);

    function onCurrentCommentPageChanged(pageNum) {
      getCommentList(props.id, pageNum, commentPageSize).then(function (data) {
        currentCommentPageNum.value = pageNum;
        commentCount.value = parseInt(data.total);
        comments.splice.apply(comments, [0, comments.length].concat(_toConsumableArray(data.rows)));
        nextTick(function () {
          renderByMathjax(".comment-item-content");
          buildCodeBlock(".comment-item-content");
        });
      });
    }

    function editArticle() {
      router.push("/article/".concat(props.id, "/edit"));
    } // 添加评论


    var mavonToolbarOption = {
      bold: true,
      // 粗体
      italic: true,
      // 斜体
      header: true,
      // 标题
      underline: true,
      // 下划线
      strikethrough: true,
      // 中划线
      mark: true,
      // 标记
      superscript: true,
      // 上角标
      subscript: true,
      // 下角标
      quote: true,
      // 引用
      ol: true,
      // 有序列表
      ul: true,
      // 无序列表
      link: true,
      // 链接
      imagelink: true,
      // 图片链接
      code: true,
      // code
      table: true,
      // 表格
      fullscreen: true,
      // 全屏编辑
      help: true,
      // 帮助
      navigation: true,
      // 导航目录
      alignleft: true,
      // 左对齐
      aligncenter: true,
      // 居中
      alignright: true,
      // 右对齐
      subfield: true,
      // 单双栏模式
      preview: true // 预览

    };
    var commentContent = ref("");
    var isInEditMode = ref(false);
    var editedComment = {};
    var mavonRef = ref();

    function onImageAdded(pos, file) {
      uploadImage(file).then(function (url) {
        mavonRef.value.$img2Url(pos, url);
      });
    }

    function submitComment() {
      if (commentContent.value.trim().length == 0) {
        ElMessage.warning("评论内容不能为空哦~");
        return;
      }

      if (!isInEditMode.value) {
        var promise = addComment(props.id, commentContent.value);
      } else {
        var promise = updateComment(editedComment.id, commentContent.value);
      }

      promise.then(function () {
        ElMessage.success("吐槽成功啦");
        commentContent.value = "";
        onCurrentCommentPageChanged(currentCommentPageNum.value);
      });
      isInEditMode.value = false;
    }

    function onReplyComment(comment) {
      commentContent.value = "@".concat(comment.userName, "\n>").concat(comment.content.replace(/\n/g, "\n>"), "\n\n");
    }

    function onDeleteComment(comment) {
      ElMessageBox.confirm("前辈确定删除这条评论吗？", "一条友善的提示", {
        confirmButtonText: "你在教我做事？",
        cancelButtonText: "我再想想",
        type: "warning"
      }).then(function () {
        deleteComment(comment.id).then(function () {
          ElMessage.success("删除评论成功~");
          onCurrentCommentPageChanged(0);
        });
      });
    }

    function onUpdateComment(comment) {
      commentContent.value = comment.content;
      isInEditMode.value = true;
      editedComment = comment;
    }

    return {
      isAdmin: isAdmin,
      articleDetails: articleDetails,
      articleLoaded: articleLoaded,
      adminInfo: adminInfo,
      articleUrl: articleUrl,
      comments: comments,
      commentCount: commentCount,
      commentPageSize: commentPageSize,
      currentCommentPageNum: currentCommentPageNum,
      useDefaultThumbnail: useDefaultThumbnail,
      onCurrentCommentPageChanged: onCurrentCommentPageChanged,
      previousArticle: previousArticle,
      nextArticle: nextArticle,
      lightBoxRef: lightBoxRef,
      mavonToolbarOption: mavonToolbarOption,
      commentContent: commentContent,
      mavonRef: mavonRef,
      isInEditMode: isInEditMode,
      editArticle: editArticle,
      onImageAdded: onImageAdded,
      submitComment: submitComment,
      onDeleteComment: onDeleteComment,
      onReplyComment: onReplyComment,
      onUpdateComment: onUpdateComment
    };
  },
  props: ["id"]
};